import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { Map } from 'immutable';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core';
import { FHEListingHeader } from 'data/components';
import { tools } from 'data/common';
import renderEnvComponent from 'data/common/renderEnvComponent';
import { ApplianceIconComponent } from 'data/common/iconsvg';
import SDM20LHTOutput from './SDM20LHTOutput';

class SDM20LHT extends PureComponent {
    static propTypes = {
        product: PropTypes.object.isRequired,
        classes: PropTypes.object.isRequired,
        productModules: PropTypes.object.isRequired,
        theme: PropTypes.object.isRequired,
        fheCenter_mac: PropTypes.string
    };

    static defaultProps = {
        fheCenter_mac: null
    };

    render() {
        const { productModules, classes, theme, product, fheCenter_mac } = this.props;
        return (
            <Fragment>
                <div className={classes.detailPanelContainer}>
                    <FHEListingHeader
                        title={Translator.translate('general.productModules.outputs')}
                        svgimage={<ApplianceIconComponent productModule={product} color={theme.palette.colors.white} size={30} />}
                    />
                </div>
                <div className={classes.detailPanel}>
                    {productModules.toArray().map(module => (
                        <SDM20LHTOutput key={module.get('code')} module={module} product={product} fheCenter_mac={fheCenter_mac} />
                    ))}
                </div>
            </Fragment>
        );
    }
}

function mapStateToProps(state, props) {
    const { history } = props;
    const productKey = props.productKey;
    const product = state.environments[history.environment].data.Products.getIn(['list', productKey], new Map());
    let productModules = state.environments[history.environment].data.Products.getIn(['list', productKey, 'productModules'], new Map());

    return {
        productModules: productModules,
        profile: state.data.user,
        productKey,
        product
    };
}

const styles = theme => ({
    loadingContainer: {
        textAlign: 'center',
        margin: 20
    },
    detailPanelContainer: {
        marginTop: 10,
        marginBottom: -5
    },
    accordionTitle: {
        paddingLeft: 10,
        color: theme.palette.common.black
    }
});
export default withRouter(
    renderEnvComponent(
        'scenes/Products/components/Product/Fhe/SDM20LHT/index',
        connect(
            mapStateToProps,
            (dispatch, ownProps) => bindActionCreators(tools.mergePropsToAction(ownProps.history.environment, {}), dispatch)
        )(withStyles(styles, { withTheme: true })(SDM20LHT))
    )
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Products/components/Product/Fhe/SDM20LHT/index.js